import { render, staticRenderFns } from "./CadastrosApp.vue?vue&type=template&id=727f5d18&scoped=true"
import script from "./CadastrosApp.vue?vue&type=script&lang=js"
export * from "./CadastrosApp.vue?vue&type=script&lang=js"
import style0 from "./CadastrosApp.vue?vue&type=style&index=0&id=727f5d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727f5d18",
  null
  
)

export default component.exports